<template>
    <b-card no-body :header="$t('prod_scaledata', { ns: 'production' }) + ' - ' +  $t('prod_inpekel', { ns: 'production' })">
        <b-table
            :items="groupedDisplayList"
            :fields="visibleFields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            stacked="md"
            show-empty
            :empty-text="$t('com_geen_data', { ns: 'common' })"
            small
            striped
            @filtered="onFiltered"
        >
            <template v-slot:cell(actions)="row">
                <b-button
                    size="sm"
                    @click="linkItem(row.item)"
                    class="bgc_aux_normal"
                    ><font-awesome-icon icon="link" size="1x" />
                </b-button>
                <b-button
                    size="sm"
                    @click="toonStappen(row.item)"
                    class="bgc_aux_unknown"
                    ><font-awesome-icon icon="info-circle" size="1x" />
                </b-button>
            </template>

            <template v-slot:row-details>
                <b-table
                    striped
                    responsive
                    :fields="detailFields"
                    :items="detailList"
                />
            </template>
        </b-table>
        <bak-selector
            v-if="showBakSelector"
            :visible="showBakSelector"
            :datum="prodTijd"
            @input="setBatch"
        />
    </b-card>
</template>

<script>
import { loadItem, loadList } from '@/models/DataHelper';
import { ScaleInfo } from '@/models/BakInfo';
import DateHelper from '@/models/DateHelper';
import BakSelector from '../components/BakSelector.vue';

export default {
    name: 'CardFixScaleVP',
    data() {
        return {
            totalRows: 1,
            currentPage: 1,
            perPage: 20,
            pageOptions: [10, 20, 40, { value: 100, text: '100' }],
            filter: null,
            list: null,
            filterOn: [],
            detaillist: [],
            selectedItem: null,
            prodTijd: null,
            showBakSelector: false
        };
    },
    components: {
        BakSelector
    },
    props: {
        theList: {
            default: null
        },
        editAllowed: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        readonly() {
            return !this.editAllowed;
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                {
                    key: 'tijd',
                    label: this.$t('com_tijd', { ns: 'common' }),
                    sortable: true,
                    visible: true,
                    formatter: this.displayDate
                },
                {
                    key: 'key',
                    label: this.$t('com_keynaam', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'stappen.length',
                    label: this.$t('prod_steps', { ns: 'production' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        detailFields() {
            const fieldsInit = [
                {
                    key: 'key',
                    label: this.$t('com_keynaam', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'veld',
                    label: this.$t('com_naam', { ns: 'common' }),
                    sortable: false,
                    visible: true
                },
                {
                    key: 'value',
                    label: this.$t('com_waarde', { ns: 'common' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        groupedDisplayList() {
            if (this.list == undefined) return null;
            const x = _(this.list.slice(0))
                .groupBy((x) => x.key)
                .map((value, key) => {
                    const tijd = value[0].tijd;
                    return {
                        tijd: tijd,
                        key: key,
                        stappen: value
                    };
                })
                .value();
            return x;
        }
    },
    methods: {
        displayDate(value) {
            return DateHelper.convertedToDate(value, false);
        },
        displayDateTime(value) {
            return DateHelper.convertedToDateTimeShort(value);
        },

        toonStappen(row) {
            if (row._showDetails) {
                this.$set(row, '_showDetails', false);
            } else {
                this.groupedDisplayList.forEach((row) => {
                    this.$set(row, '_showDetails', false);
                });

                const item = row.item ? row.item : row;
                this.detailList = item.stappen.sort(
                    (a, b) => a.stapnummer - b.stapnummer
                );
                this.$set(row, '_showDetails', true);
            }
        },
        reset() {
            this.showBakSelector = false;
        },
        async getBatchParams(bakID) {
            const o = { batchID: bakID };
            const currentBak = await loadItem(
                'production/loadBatch',
                o,
                this.$t
            );
            const selectionData = {
                bookdate: currentBak.productieDatum
            };
            const prodinfoLijst = await loadList(
                'production/getBatchInfoLijst',
                'production/loadBatchInfo',
                selectionData,
                true,
                this.$t
            );
            const prodinfo = prodinfoLijst.find((x) => x.id == bakID);
            return { currentBak, prodinfo };
        },
        async setBatch(bakID) {
            if (bakID == null || bakID <= 0 || this.selectedItem == null) {
                this.showBakSelector = false;
                return;
            }
            //mogelijk straks uit bakselector halen
            const altDatum = DateHelper.convertedToDateTimeStringFromUTC(
                new Date()
            );
            const o = await this.getBatchParams(bakID);
            const currentBak = o.currentBak;
            const item = o.prodinfo;
            const inBrineModel = {
                BatchID: bakID,
                Amounts: [],
                DataKey: this.selectedItem
            };
            const datum = DateHelper.localDateToUTC(this.selectedItem.created);
            const weegschaal = new ScaleInfo();
            const items = this.list.filter((x) => x.key === this.selectedItem.key);
            weegschaal.dataKey = this.selectedItem.key;
            weegschaal.processed = this.selectedItem.tijd;
            for (let i = 0; i < items.length; i++) {
                if (items[i].veld === "ba-amountvp") weegschaal.amount= items[i].value;
                if (items[i].veld === "ba-weightvp-netto") weegschaal.nettoKg= items[i].value;
                if (items[i].veld === "ba-weightvp-bruto") weegschaal.brutoKg= items[i].value;
                if (items[i].veld === "ba-weightvp-tarra") weegschaal.tarraKg= items[i].value;
            }
            const Amount = {
                CheeseAmount: weegschaal.amount,
                CheeseWeight: weegschaal.nettoKg
                    ? weegschaal.nettoKg
                    : null,
                ShapeID: item?.vormID,
                ProductID: item?.productID,
                InBrineTime: datum,
                Updated: altDatum,
                ScaleData: weegschaal
            };
            inBrineModel.Amounts.push(Amount);
            const result = await loadItem(
                'production/updateBatchInBrine',
                inBrineModel,
                this.$t
            );
            this.showBakSelector = false;
            this.loadData();
        },
        linkItem(item) {
            this.selectedItem = item;
            this.showBakSelector = true;
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        async loadData() {
            const report = '/Reporting/ImportScaleInBrineErrorReport';
            const payload = {
                data: null,
                report: report
            };
            this.list = await loadList(
                'rapportage/getReportItems',
                'rapportage/loadReport',
                payload,
                true,
                this.$t
            );
        }
    },
    mounted() {},
    async created() {
        if (this.theList == undefined) {
            await this.loadData();
        } else {
            this.list = this.theList;
        }
    }
};
</script>

